// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-wrapper {
  padding: 20px 30px;
  margin-bottom: 10px;
  cursor: pointer;
}
.logo-wrapper img {
  max-height: 60px;
  width: auto;
}

.sidebar-title {
  color: #aaa;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
  padding: 15px 30px;
}

::ng-deep .sidebar-menu.p-menu {
  width: 100%;
  border: none;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link {
  font-size: 16px !important;
  font-weight: 700 !important;
  padding: 16px 30px 13px;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link .p-menuitem-text {
  transition: all ease 0.3s;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link:hover {
  background-color: #ebf8ff !important;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link:hover .p-menuitem-text {
  color: #0482c5 !important;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem.p-focus,
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link-active {
  background-color: #ebf8ff !important;
}
::ng-deep .sidebar-menu.p-menu .p-menuitem.p-focus .p-menuitem-text,
::ng-deep .sidebar-menu.p-menu .p-menuitem .p-menuitem-link-active .p-menuitem-text {
  color: #0482c5 !important;
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.refresh-block {
  margin-top: auto;
  display: block;
  margin-bottom: 18px;
}
.refresh-block a {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 54px 10px 29px;
  transition: 0.1s ease;
}
.refresh-block a.disabledButton {
  pointer-events: none;
  opacity: 0.5;
}
.refresh-block a:hover {
  background: #fff4eb;
}
.refresh-block a img {
  display: block;
}
.refresh-block a span {
  font-size: 12px;
  text-transform: uppercase;
  color: #777777;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  line-height: 16px;
}
.refresh-block a span b {
  font-size: 16px;
  text-transform: none;
  color: #333333;
  font-weight: 700;
  line-height: 16px;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./projects/admin/src/app/components/widgets/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AACF;AAAE;EACE,gBAAA;EACA,WAAA;AAEJ;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;AAEI;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;AAAN;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,oCAAA;AADR;AAGQ;EACE,yBAAA;AADV;AAMI;;EAEE,oCAAA;AAJN;AAMM;;EACE,yBAAA;AAHR;;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AANF;;AAQA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AALF;AAME;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;AAJJ;AAKI;EACE,oBAAA;EACA,YAAA;AAHN;AAKI;EACE,mBAAA;AAHN;AAKI;EACE,cAAA;AAHN;AAKI;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAHN;AAIM;EACE,eAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAFR","sourcesContent":[".logo-wrapper {\n  padding: 20px 30px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  img {\n    max-height: 60px;\n    width: auto;\n  }\n}\n\n.sidebar-title {\n  color: #aaa;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 15px 30px;\n}\n\n::ng-deep .sidebar-menu.p-menu {\n  width: 100%;\n  border: none;\n\n  .p-menuitem {\n    .p-menuitem-link {\n      font-size: 16px !important;\n      font-weight: 700 !important;\n      padding: 16px 30px 13px;\n\n      .p-menuitem-text {\n        transition: all ease 0.3s;\n      }\n\n      &:hover {\n        background-color: #ebf8ff !important;\n\n        .p-menuitem-text {\n          color: #0482c5 !important;\n        }\n      }\n    }\n\n    &.p-focus,\n    .p-menuitem-link-active {\n      background-color: #ebf8ff !important;\n\n      .p-menuitem-text {\n        color: #0482c5 !important;\n      }\n    }\n  }\n}\n\n:host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.refresh-block {\n  margin-top: auto;\n  display: block;\n  margin-bottom: 18px;\n  a {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    padding: 10px 54px 10px 29px;\n    transition: 0.1s ease;\n    &.disabledButton {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n    &:hover {\n      background: #fff4eb;\n    }\n    img {\n      display: block;\n    }\n    span {\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #777777;\n      font-weight: 400;\n      display: flex;\n      flex-direction: column;\n      line-height: 16px;\n      b {\n        font-size: 16px;\n        text-transform: none;\n        color: #333333;\n        font-weight: 700;\n        line-height: 16px;\n        margin-top: 2px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
